// 用户相关文案
export default {
  login: '登入',
  logout: '登出',
};
